"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelHead = void 0;
var React = __importStar(require("react"));
var material_1 = require("@mui/material");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var useStyles = (0, makeStyles_1.default)(function (t) {
    var _a;
    return (0, createStyles_1.default)({
        root: (_a = {
                paddingLeft: t.spacing(2)
            },
            _a[t.breakpoints.up('sm')] = {
                paddingLeft: t.spacing(3),
                paddingRight: t.spacing(3),
            },
            _a.display = 'flex',
            _a.alignItems = 'center',
            _a.color = t.palette.text.secondary,
            _a.background = t.palette.mode === 'light' ? t.palette.grey[100] : t.palette.grey[900],
            _a.paddingRight = t.spacing(1) + 'px !important',
            _a.order = -1,
            _a.height = 48,
            _a),
        icon: {
            marginRight: t.spacing(2),
        },
        content: {
            flex: 1,
        },
    });
});
var PanelHead = function (_a) {
    var className = _a.className, icon = _a.icon, children = _a.children, action = _a.action;
    var classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.root + " " + (className || '') },
            icon &&
                React.createElement(material_1.Icon, { className: classes.icon }, icon),
            React.createElement("div", { className: classes.content }, children),
            React.createElement("div", null, action)),
        React.createElement(material_1.Divider, null)));
};
exports.PanelHead = PanelHead;
//# sourceMappingURL=PanelHead.js.map